// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TK86W","label":"styles_label__QjY5E"};